import { createObservableRef } from '@utils/react';

const ThrobberVisibleState = createObservableRef(false);
const PrinterState = createObservableRef(undefined);

export { PrinterState, ThrobberVisibleState };
//# sourceMappingURL=store.js.map
